import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const defaults = {
  width: 20,
  height: 20,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;

export const IconCrossPlatform = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18" />
    <path d="M12 3a14.5 14.5 0 0 1 0 18M12 3a14.5 14.5 0 0 0 0 18" />
  </svg>
);

export const IconAttribution = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M3 19V5" />
    <path d="M3 19h18" />
    <path d="M7 15l4-5 3 3 5-7" />
  </svg>
);

export const IconWidget = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <rect x="3" y="4" width="18" height="14" rx="2" />
    <path d="M3 9h18" />
    <circle cx="7" cy="6.5" r="0.6" fill="currentColor" />
  </svg>
);

export const IconShield = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M12 3 4 6v6c0 5 4 8 8 9 4-1 8-4 8-9V6l-8-3Z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

export const IconWebhook = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <circle cx="6" cy="18" r="2.5" />
    <circle cx="18" cy="18" r="2.5" />
    <circle cx="12" cy="6" r="2.5" />
    <path d="m13.3 8 4.7 8" />
    <path d="m10.7 8-4.7 8" />
    <path d="M8.5 18h7" />
  </svg>
);

export const IconCustomize = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M3 21l3-1 11-11-2-2L4 18l-1 3Z" />
    <path d="m14 7 3 3" />
  </svg>
);

export const IconLightning = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />
  </svg>
);

export const IconKey = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <circle cx="8" cy="14" r="4" />
    <path d="m11 11 9-9" />
    <path d="m17 5 3 3" />
    <path d="m15 7 3 3" />
  </svg>
);

export const IconCode = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="m9 8-5 4 5 4" />
    <path d="m15 8 5 4-5 4" />
    <path d="m13 6-2 12" />
  </svg>
);

export const IconChart = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M3 20V8" />
    <path d="M9 20V4" />
    <path d="M15 20v-9" />
    <path d="M21 20v-5" />
  </svg>
);

export const IconUsers = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2 20c0-3.5 3-6 7-6s7 2.5 7 6" />
    <circle cx="17" cy="9" r="2.5" />
    <path d="M16 14c3 0 6 2 6 5" />
  </svg>
);

export const IconLink = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M10 14a4 4 0 0 1 0-5.7l3-3a4 4 0 0 1 5.7 5.7l-1.5 1.5" />
    <path d="M14 10a4 4 0 0 1 0 5.7l-3 3a4 4 0 0 1-5.7-5.7l1.5-1.5" />
  </svg>
);

export const IconLayers = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="m12 3 9 5-9 5-9-5 9-5Z" />
    <path d="m3 13 9 5 9-5" />
    <path d="m3 18 9 5 9-5" />
  </svg>
);

export const IconSparkle = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4" />
    <path d="m6 6 2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6" />
  </svg>
);

export const IconCheck = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="m5 12 4 4 10-10" />
  </svg>
);

export const IconArrowRight = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M5 12h14m0 0-5-5m5 5-5 5" />
  </svg>
);

export const IconPlay = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M6 4v16l14-8L6 4Z" fill="currentColor" stroke="none" />
  </svg>
);

export const IconGlobe = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" />
  </svg>
);

export const IconBolt = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <path d="M14 2 5 14h6l-1 8 9-12h-6l1-8Z" />
  </svg>
);

export const IconDevice = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <rect x="3" y="4" width="13" height="14" rx="2" />
    <rect x="14" y="9" width="7" height="11" rx="1.5" />
    <path d="M3 15h13" />
  </svg>
);

export const IconTerminal = (p: IconProps) => (
  <svg {...defaults} {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <path d="m7 9 3 3-3 3M12 15h5" />
  </svg>
);
